import { LungDashboard } from "./dashboard";
import { LungFilters } from "./filters";
import * as React from "react";

export { LungFilters }


export class LungDashboardHome extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            width: 0,
            height: 0
        };       

    }

    private updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
      };
    
    public componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }
       
    public componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    render = () => {
        return (
            <>
                <LungDashboard />
            </>
        )

    }
}
